import { FC, useContext } from "react";
import React from "react";
import { NotificationSubscriptionContext } from "../subscriptions/notification-subscription-provider";
import { AlertBell } from "@design-system";
import { useNavigate } from "react-router";
import styles from "./header-notification-container.css";
import { NotificationType } from "../../graphql/types";
import { NotificationBell } from "@design-system";

export const HeaderNotificationContainer: FC = () => {
  const navigate = useNavigate();

  const { notificationContext, resetNotificationCount } = useContext(
    NotificationSubscriptionContext
  );

  const handleBellClick = (notificationType: NotificationType) => {
    resetNotificationCount(notificationType);
    navigate("/", { state: { notificationType } });
  };

  return (
    <div className={styles["bell-wrapper"]}>
      <span className={styles.bell}>
        <AlertBell
          onBellClick={() =>
            notificationContext.alert.count > 0 && handleBellClick(NotificationType.Alert)
          }
          count={notificationContext.alert.count}
        ></AlertBell>
      </span>
      <span className={styles.bell}>
        <NotificationBell
          onBellClick={() =>
            notificationContext.standard.count > 0 && handleBellClick(NotificationType.Standard)
          }
          count={notificationContext.standard.count}
        ></NotificationBell>
      </span>
    </div>
  );
};
